import type { GoldRunView } from './gold-timeline';

export type SettlementStatus = 'idle' | 'pending' | 'retry' | 'done';

/** Retry result delivery only; the authoritative game is already saved. */
export function createSettlementRecovery(
  complete: (run: GoldRunView) => void | Promise<void>,
  status: (state: SettlementStatus) => void,
) {
  let saved: GoldRunView | undefined;
  let timer: ReturnType<typeof setTimeout> | undefined;
  let inFlight = false;
  let done = false;
  let disposed = false;

  const retry = async () => {
    if (!saved || disposed || done || inFlight) return;
    clearTimeout(timer);
    inFlight = true;
    status('pending');
    try {
      await complete(saved);
      if (!disposed) {
        done = true;
        status('done');
      }
    } catch {
      if (!disposed) {
        status('retry');
        timer = setTimeout(() => { void retry(); }, 1200);
      }
    } finally {
      inFlight = false;
    }
  };

  return {
    accept(run: GoldRunView) {
      if (saved || disposed || run.phase !== 'SETTLED') return;
      saved = run;
      status('pending');
      timer = setTimeout(() => { void retry(); }, 350);
    },
    retry,
    dispose() {
      disposed = true;
      clearTimeout(timer);
    },
  };
}
